
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearDay as ObiClearDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-day.js';
 
 
 

 
 export const ObiClearDay = createComponent({
   react: React,
   tagName: 'obi-clear-day',
   elementClass: ObiClearDayElement,
   events: {
     
   }
  });
 
 